// @flow
import * as React from 'react';

import type { HostingPlan } from './types';

type Context = {
  plan: HostingPlan,
  productId: ?number,
  isDiscountPeriod: boolean,
};

export const ProductContext: React$Context<Context> =
  React.createContext<Context>({
    plan: 'monthly',
    productId: undefined,
    isDiscountPeriod: false,
  });
